import Vue from 'vue';
import axios from 'axios';
import App from './App.vue';
import VueNumeric from 'vue-numeric';
import '@/assets/css/tailwind.css';
import data from './data';
import VModal from 'vue-js-modal';

Vue.use(VModal);
Vue.use(VueNumeric);

Vue.config.productionTip = false;

new Vue({
  render: (h) => h(App),
  data: () => ({
    loaded: false,
    stepping: false,
    language: '',
    ...data,
  }),
  computed: {
    currency() {
      if (this.$root.countries.selected === 'uk') {
        return '£';
      } else if (this.$root.countries.selected === 'sg') {
        return 'S$';
      } else if (this.$root.countries.selected === 'hk') {
        return 'HKD$';
      } else {
        return '€';
      }
    },

    backButtonShown() {
      return this.currentStep >= 1;
    },
    backButtonText() {
      return this.currentStep < this.steps.length - 1
        ? this.globalOptions.back_button
        : this.globalOptions.try_again_button;
    },
    nextButtonText() {
      return this.currentStep < this.steps.length - 1
        ? this.globalOptions.next_button
        : this.globalOptions.whats_next_button;
    },
    isFinalStep() {
      return this.currentStep === this.steps.length - 1;
    },

    discountCalc() {
      return this.discount / 100;
    },

    seedfastVal() {
      let val;
      const discountVal = this.valuation * (1 - this.discountCalc);
      const isFrance = this.countries.selected === 'fr';
      const lowValue = isFrance ? this.floor : this.low;

      if (discountVal > this.cap) {
        val = this.cap;
      } else if (discountVal < lowValue) {
        val = lowValue;
      } else {
        val = discountVal;
      }

      return val;
    },

    seedfastDil() {
      return this.rounded(
        (this.raising /
          (this.seedfastVal || 1) /
          (1 +
            this.raising / (this.seedfastVal || 1) +
            this.nextRound / this.valuation)) *
          100
      );
    },

    lateSeedfastDil() {
      return this.rounded(
        (this.raising / (this.low + this.raising || 1)) * 100
      );
    },

    newMoneyDil() {
      return this.rounded(
        (this.nextRound /
          this.valuation /
          (1 +
            this.raising / (this.seedfastVal || 1) +
            this.nextRound / (this.valuation || 1))) *
          100
      );
    },

    totalDil() {
      return this.rounded(this.seedfastDil + this.newMoneyDil);
    },

    lateDil() {
      console.log(this.raising / (this.low + this.raising || 1));
      return this.rounded(this.raising / (this.low + this.raising || 1));
    },
  },
  methods: {
    rounded(v) {
      return +v.toFixed(2);
    },
    prevStep() {
      if (this.isFinalStep) {
        return (this.currentStep = 0);
      } else {
        return this.currentStep > 0 ? this.currentStep-- : false;
      }
    },

    nextStep() {
      if (this.isFinalStep) {
        this.$modal.show('contact');
      } else {
        this.currentStep++;
      }
    },
    sendPostMessage() {
      if (!window.parent || !this.loaded || !document.querySelector('.screen'))
        return;

      if (this.height !== document.querySelector('.screen').offsetHeight) {
        this.height = document.querySelector(
          '.screen'
        ).offsetHeight;
        window.parent.postMessage(
          {
            frameHeight: this
              .height,
          },
          '*'
        );
        // console.log(this.height);
      }
    },
  },
  watch: {
    currentStep() {
      setTimeout(() => {
        this.sendPostMessage();
      }, 20);
    },
    stepping() {
      setTimeout(() => {
        this.sendPostMessage();
      }, 20);
    },
  },
  async mounted() {
    function parseQuery(queryString) {
      var query = {};
      var pairs = (queryString[0] === '?'
        ? queryString.substr(1)
        : queryString
      ).split('&');
      for (var i = 0; i < pairs.length; i++) {
        var pair = pairs[i].split('=');
        query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
      }
      return query;
    }

    const { lang = '' } = parseQuery(window.location.search);
    const hostname = `https://seedlegals.com`;
    const url = `${hostname}/${lang && lang + '/'}wp-json/acf/v3/options/options?v=${+new Date()}`;

    const { data } = await axios({
      method: 'get',
      url,
    });

    this.$root.language = lang || 'en';
    this.$root.steps = data.acf.steps;
    this.$root.intro = data.acf.sf_intro;

    this.$root.countries = {
      list: data.acf.steps[0].questions[0].input.options,
      selected: data.acf.steps[0].questions[0].input.options[0].value,
      otherName: '',
    };

    const form = data.acf.sf_form;
    this.$root.modalFields = {
      heading: form.heading,
      content: form.content,
      confirmation: form.confirmation,
      form: [
        {
          label: form.fields.first_name,
          type: 'text',
          value: '',
        },
        {
          label: form.fields.last_name,
          type: 'text',
          value: '',
        },
        {
          label: form.fields.email,
          type: 'email',
          value: '',
        },
      ],
    };

    this.$root.globalOptions = data.acf.sf_options;
    this.$root.results = data.acf.sf_results.columns;

    this.loaded = true;
// console.log(this);
// console.log(this.raising);
// console.log(this.seedfastVal);
    setTimeout(() => {
      this.sendPostMessage();
    }, 50);
  },
}).$mount('#app');
